import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/components/index'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
    path: '/',
    name: 'index',
    redirect: '/home',
    meta: {
        title: '主框架'
    },
    component: index,
    children: [
        {
            path: '/home',
            component: resolve => require(['@/pages/home/home.vue'], resolve),
            meta: {
                title: '企业首页'
            }
        }, {
            path: '/course',
            component: resolve => require(['@/pages/course/course.vue'], resolve),
            meta: {
                title: '产品中心'
            }
        }, {
            path: '/course/view/:id',
            name: 'courseDetail',
            meta: {
                title: '产品详情',
                activeMenu: '/course'
            },
            component: resolve => require(['@/pages/course/content/detail.vue'], resolve),
        }, {
            path: '/news',
            component: resolve => require(['@/pages/news/news.vue'], resolve),
            meta: {
                title: '新闻中心'
            }
        }, {
            path: '/newsDetail/:id',
            component: resolve => require(['@/pages/news/newsDetail.vue'], resolve),
            meta: {
                title: '新闻中心详情',
                activeMenu: '/news'
            }
        }, {
            path: '/contactUs',
            component: resolve => require(['@/pages/contactUs/contactUs.vue'], resolve),
            meta: {
                title: '联系我们'
            }
        }, {
            path: '/search',
            name: '/search',
            component: resolve => require(['@/pages/search/index.vue'], resolve),
            meta: {
                title: '全局搜索',
                // type: 'login' // 是否需要判断是否登录,这里是需要判断
            }
        }
    ],
},

]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
